import React from 'react';
import Icon from '../../../components/AppIcon';
import { cn } from '../../../utils/cn';

const ApplicationProgress = ({ steps, currentStep }) => {
  return (
    <div className="glass-container rounded-2xl p-6">
      <div className="flex items-center justify-between">
        {steps?.map((step, index) => (
          <React.Fragment key={step?.id}>
            {/* Step */}
            <div className="flex flex-col items-center gap-2 flex-1">
              {/* Icon */}
              <div
                className={cn(
                  'w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300',
                  step?.id < currentStep && 'bg-success text-success-foreground',
                  step?.id === currentStep && 'bg-primary text-primary-foreground ring-4 ring-primary/20',
                  step?.id > currentStep && 'bg-muted text-muted-foreground'
                )}
              >
                {step?.id < currentStep ? (
                  <Icon name="Check" size={24} />
                ) : (
                  <Icon name={step?.icon} size={24} />
                )}
              </div>

              {/* Label */}
              <div className="text-center">
                <p
                  className={cn(
                    'text-sm font-semibold',
                    step?.id <= currentStep ? 'text-foreground' : 'text-muted-foreground'
                  )}
                >
                  {step?.title}
                </p>
                <p className="text-xs text-muted-foreground hidden sm:block">
                  {step?.description}
                </p>
              </div>
            </div>

            {/* Connector Line */}
            {index < steps?.length - 1 && (
              <div className="flex-1 h-0.5 mx-2 mb-8">
                <div
                  className={cn(
                    'h-full transition-all duration-300',
                    step?.id < currentStep ? 'bg-success' : 'bg-muted'
                  )}
                />
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default ApplicationProgress;